var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Top'),_vm._v(" "),_c('TopNav'),_vm._v(" "),_c('div',{staticClass:"content-wrap"},[_c('nuxt')],1),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }